(() => {
  const init = (section) => {
    const container = section.querySelector(".swiper--blog-posts");
    if (!container || container.swiper) return;

    const wrapper = container.querySelector(".blog-posts-grid");
    if (!wrapper) return;

    const slides = wrapper.querySelectorAll(".blog-posts-card");
    if (!slides.length) return;

    container.classList.add("swiper");
    wrapper.classList.add("swiper-wrapper");

    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });

    const pagination = section.querySelector(".blog-posts-swiper__pagination");

    new Swiper(container, {
      slidesPerView: "auto",
      spaceBetween: 20,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      a11y: {
        enabled: true,
        slideRole: "listitem",
      },
      mousewheel: {
        forceToAxis: true,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
    });
  };

  const initBlogPostsSections = () =>
    document.querySelectorAll(".blog-posts").forEach(init);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBlogPostsSections);
  } else {
    initBlogPostsSections();
  }

  document.addEventListener("shopify:section:load", (e) => init(e.target));
})();
